module.exports = __webpack_public_path__ + "static/src/content/images/processed/600/placeholder.46c2e58.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/600/placeholder.jpg
// module id = x2z2
// module chunks = 0